import React from "react";

const OurInformation = () => {
   const cards = [
    {
      title: "Creative Excellence ",
      icon: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01" />
        </svg>
      ),
      description:
        "Where imagination meets execution. Our artists and designers combine creative vision with fine craftsmanship to produce art prints, wallpapers, and hand-painted works that elevate your interiors and reflect your personality.",
    },
    {
      title: "End-to-End Service ",
      icon: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      description:
        "From concept to installation. We handle everything – understanding your requirements, designing the artwork, customizing details, and installing the final piece, ensuring a seamless and satisfying experience.",
    },
    {
      title: "Quality Materials ",
      icon: (
        <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      description:
        "Made to impress. Built to last. We use premium materials and printing techniques to ensure every piece looks stunning and stays beautiful over time.",
    },
  ];

  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-10" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <div className="text-center mb-16">
          <h3 className="text-4xl  inline-block relative group">
            <span className="bg-gradient-to-r from-gray-500 to-gray-500 bg-clip-text text-transparent font-serif">
              What We Do
            </span>
            <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-aber-900 to-amber-700 transform scale-x-100 transition-transform duration-300" />
          </h3>
          <p className="mt-8 text-gray-500 text-base md:text-lg leading-relaxed max-w-3xl mx-auto font-serif">
            At VIZAURA, we bring artistry to your walls with custom wallpapers, hand paintings, art prints, and tailored designs, crafted by expert designers who understand your space and style.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              className="group flex flex-col h-full bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200 p-6"
            >
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 p-3 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full shadow-md group-hover:scale-110 transition-transform duration-300">
                <div className="text-gray-500 group-hover:text-gray-900 transition-colors duration-300">
                  {card.icon}
                </div>
              </div>

              <h4 className="mt-8 mb-6 text-xl font-semibold bg-gradient-to-r from-gray-500 to-gray-500 bg-clip-text text-transparent font-serif">
                {card.title}
              </h4>
              
              <p className="text-gray-500 text-sm leading-relaxed font-semibold">
                {card.description}
              </p>

                {/* <div className="mt-6">
                  <div className="text-sm text-amber-900 font-medium flex items-center group/arrow">
                    Learn more
                    <svg 
                      className="w-4 h-4 ml-2 transform group-hover/arrow:translate-x-1 transition-transform duration-200" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </div>
                </div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurInformation;